import React from 'react';
import { logger as LOG } from '@garnish/logger';
import { useActor } from '@xstate/react';

import { useGlobalAppState } from '../../GlobalAppState';
import { AuthModel } from '../AuthMachine.model';

// ────────────────────────────────────────────────────────────────────────────────
// LOG.enable('AUTH');
const logger = LOG.extend('AUTH');
// ────────────────────────────────────────────────────────────────────────────────

export const useSendLoginToAuthMachine = () => {
  const { authMachineRef } = useGlobalAppState();
  const authMachine = useActor(authMachineRef);
  const { 1: send } = authMachine;

  const sendLoginAction = React.useCallback(
    (csrf?: string) => {
      logger.debug('sending LOGIN event to AuthMachine');
      send(AuthModel.events.LOGIN(csrf));
    },
    [send],
  );

  return sendLoginAction;
};
